"use client";

import ErrorAlert from "@/components/alerts/errorsAlert";
import ExitoAlert from "@/components/alerts/ExitosAlert";
import React from "react";
import FormResetPassword from "./Components/ResetPassword";
import { useResetPassword } from "./Hooks/useResetPassword";

export const ResetPasswordClient: React.FC = () => {
  const {
    email,
    emailError,
    onEmailChange,
    onSubmit,
    acceptTerms,
    onAcceptTermsChange,
    isCheckboxDisabled,
    tipoDocumento,
    numeroDocumento,
    numeroDocumentoError,
    onTipoDocumentoChange,
    onNumeroDocumentoChange,
    loading,
    tiposIdentificacion,
    loadingTipos,
    apiErrorUser,
    showErrorAlert,
    showSuccessAlert,
    successData,
    onCloseErrorAlert,
    onCloseSuccessAlert,
  } = useResetPassword();

  return (
    <>
      <FormResetPassword
        email={email}
        emailError={emailError}
        onEmailChange={onEmailChange}
        onSubmit={onSubmit}
        acceptTerms={acceptTerms}
        isCheckboxDisabled={isCheckboxDisabled}
        tipoDocumento={tipoDocumento}
        numeroDocumento={numeroDocumento}
        numeroDocumentoError={numeroDocumentoError}
        onTipoDocumentoChange={onTipoDocumentoChange}
        onNumeroDocumentoChange={onNumeroDocumentoChange}
        onAcceptTermsChange={onAcceptTermsChange}
        loading={loading}
        tiposIdentificacion={tiposIdentificacion}
        loadingTipos={loadingTipos}
      />

      {showErrorAlert && apiErrorUser && (
        <ErrorAlert
          title="Error de recuperación"
          message={apiErrorUser}
          onClose={onCloseErrorAlert}
        />
      )}

      {showSuccessAlert && successData && (
        <ExitoAlert
          title={successData.title}
          message={successData.message}
          onClose={onCloseSuccessAlert}
        />
      )}
    </>
  );
};

export default ResetPasswordClient;
